export enum SliderArrowDirection {
  PREV = 'prev',
  NEXT = 'next',
}
